import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';

interface ReceiverCheckboxProps extends WithTranslation {
  checked: boolean;
  type: string;
  value: string;
  onChange?: (eventValue: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReceiverCheckbox = withTranslation(I18N_NS.PROJECT)(
  ({ checked, type, value, onChange, t }: ReceiverCheckboxProps) => {
    return (
      <div>
        <label>
          <input type="checkbox" checked={checked} value={value} id={type} onChange={onChange} />
          <span>{t(type)}:</span>
        </label>
      </div>
    );
  });
